import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setActiveNexusFilter } from "../../store/nexusFilters";
import { getPlanningDates } from "../../store/nexusFilters/action";
import Accordion from "../UI/Accordion";
import {
  resetGanttChartErrorMessage,
  setSelectedGanttChartTab,
} from "../../store/ganttChart";
import { ActiveNexusFilter } from "../../types/ganttChart";
import labels from "../../utils/labels";
import { useEffect, useState } from "react";
import allowedPaths from "../../utils/paths";

const whiteListedDevDomains = [
  "kons15.pondoo.ai",
  "omsorg-dev.pondoo.ai",
  "kons14.pondoo.ai",
  "localhost",
];
const isDevEnvironment = whiteListedDevDomains.includes(
  window.location.hostname,
);

const HeaderFilters = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterID = searchParams.get("filterId");
  const filter = searchParams.get("filter");
  const { activeNexusFilters, selectedActiveNexusFilter } = useAppSelector(
    (state) => state.nexusFiltersSlice,
  );

  const [defaultIndex, setDefaultIndex] = useState<number | undefined>();

  const handleFilterChange = (filterName: string, value?: string) => {
    dispatch(resetGanttChartErrorMessage());
    setSearchParams((prevParams) => {
      if (value) {
        prevParams.set(filterName, value);
      } else {
        prevParams.delete(filterName);
      }
      return prevParams;
    });
  };

  useEffect(() => {
    if (!activeNexusFilters) return;

    let selectedFilter: ActiveNexusFilter | undefined;
    if (filter) {
      selectedFilter = activeNexusFilters.find(
        (activeNexusFilter) => activeNexusFilter.id === parseInt(filter),
      );
      setDefaultIndex(
        activeNexusFilters!.findIndex((obj) => obj.id === selectedFilter?.id),
      );
    } else if (filterID) {
      selectedFilter = activeNexusFilters.find(
        (activeNexusFilter) =>
          activeNexusFilter.filterId === parseInt(filterID),
      );
      setDefaultIndex(
        activeNexusFilters!.findIndex(
          (obj) => obj.filterId === selectedFilter?.filterId,
        ),
      );
    }

    dispatch(setActiveNexusFilter(selectedFilter));
  }, [activeNexusFilters, filterID, filter]);

  return (
    <>
      {isDevEnvironment && activeNexusFilters && (
        <Accordion
          key={defaultIndex}
          variant="SECONDARY"
          onChange={(activeNexusFilter: ActiveNexusFilter) => {
            dispatch(getPlanningDates(activeNexusFilter.id));
            dispatch(setActiveNexusFilter(activeNexusFilter));
            handleFilterChange("filter", activeNexusFilter.id.toString());
            // We may be in the middle of a Nexus Landing flow, in which case we shouldn't trigger a global navigation
            if (location.pathname.includes(allowedPaths.nexusLanding)) return;

            // If not, we should default to an active tab
            if (location.pathname !== allowedPaths.ganttChart) {
              dispatch(setSelectedGanttChartTab("Original"));
              navigate({
                pathname: `${allowedPaths.ganttChart}`,
                search: location.search,
              });
            }
          }}
          options={activeNexusFilters}
          labelKey="filter"
          defaultText={labels.filter}
          displayOption={defaultIndex}
        />
      )}
      {selectedActiveNexusFilter && !isDevEnvironment && (
        <span style={{ font: "var(--font-button)", padding: "4px 20px" }}>
          {selectedActiveNexusFilter.filter}
        </span>
      )}
    </>
  );
};

export default HeaderFilters;
